// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1yzsh","alert":"SettungsInbox_alert__2NXip"};